// extracted by mini-css-extract-plugin
module.exports = {"contentBody":"PageContentBody-contentBody-39o5p","innerContentBody":"PageContentBody-innerContentBody-tEszh"};